var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-container",
      class: { "required-fail": _vm.requiredFail }
    },
    [
      _c("treeselect", {
        staticClass: "form-input-select",
        attrs: {
          value: _vm.value,
          options: _vm.options,
          "load-options": _vm.loadUserOptions,
          normalizer: _vm.userNormalizer,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          clearable: _vm.clearable,
          disableFuzzyMatching: ""
        },
        on: {
          input: function($event) {
            return _vm.updateValue($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c19637a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c19637a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/InputTypesNPV/InputTypeTreeSelectUserNPV.vue
// module id = null
// module chunks = 